export const routesAdmin = {
  //
  dashboard1: '/',
  dashboard2: '/dashboard',
  home: '/dashboard/home',
  //
  postsConst: '/posts',
  allPostsConst: '/posts/all-posts',
  addNewPostConst: '/posts/add-new-post',
  postCategoryConst: '/posts/post-category',
  postDataGroupConst: '/posts/data-group',
  postDataFieldConst: '/posts/data-group/typeID/data-field/groupID',
  postArticleGroupConst: '/posts/article-group',
  postTrademarkConst: '/posts/trademark-group',
  postDiscountConst: '/posts/product/discount',
  postOrderConst: '/posts/product/order',
  posts: '/posts/:typeID',
  allPosts: '/posts/all-posts/:typeID',
  addNewPost: '/posts/add-new-post/:typeID',
  postCategory: '/posts/post-category/:typeID',
  postDataGroup: '/posts/data-group/:typeID',
  postDataField: '/posts/data-group/:typeID/data-field/:groupID',
  postArticleGroup: '/posts/article-group/:typeID',
  postTrademark: '/posts/trademark-group/:typeID',
  postDiscount: '/posts/product/discount/:typeID',
  postOrder: '/posts/product/order/:typeID',
  //
  postType: '/post-type',
  postTypeManager: '/post-type/manager',
  //
  comment: '/comment',
  commentManager: '/comment/manager',
  //
  feedback: '/feedback',
  feedbackManager: '/feedback/manager',
  //
  rating: '/rating',
  ratingManager: '/rating/manager',
  //
  seo: '/seo',
  seoManager: '/seo/manager',
  //
  agencies: '/agencies',
  agenciesManager: '/agencies/manager',
  //
  warehouse: '/warehouse',
  warehouseManager: '/warehouse/manager',
  warehouseChange: '/warehouse/change',
  supplier: '/warehouse/supplier',
  //
  media: '/media',
  mediaLibrary: '/media/media-library',
  //
  users: '/users',
  usersList: '/users/list',
  userClients: '/users/client',
  usersRole: '/users/role',
  usersPermissions: '/users/permissions',
  //
  settings: '/settings',
  settingGeneral: '/settings/general',
  settingScript: '/settings/script',
  settingCompany: '/settings/company',
  settingCopyright: '/settings/copyright',
  settingEmail: '/settings/email',
  settingSocial: '/settings/social',
  settingRedirect: '/settings/redirect',
  settingDynamic: '/settings/dynamic',
  settingMenu: '/settings/menu',
  settingSlider: '/settings/slider',
  //
  appearance: '/appearance',
  appearanceMenu: '/appearance/menu',
  appearanceSlider: '/appearance/slider',
  //
  widgets: '/widgets',
  widgetsManager: '/widgets/manager',
  widgetsGroup: '/widgets/:type',
  //
  language: '/languages',
  languageManager: '/languages/manager',
};
